
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/sections/components/SectionBox/EmptyState/SectionsEmptyState.scss.css.virtualfile';
        module.exports = {"emptyStateContainer":"_emptyStateContainer_1aa30_7","linksContainer":"_linksContainer_1aa30_16","light":"_light_1aa30_19"};